import React from 'react'

export interface PageHeaderProps {
  icon?: React.ReactNode
  title?: React.ReactNode
  subtitle?: string | React.ReactNode
  right?: React.ReactNode
}

/**
 * Generic page header component with icon, title, subtitle, and right-side action area.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, subtitle, right }) => {
  return (
    <div>
      <div className='flex flex-wrap items-center justify-between gap-3 rounded-lg border border-base-300 bg-base-100 px-4 py-3 shadow-sm'>
        <div className='flex min-w-0 items-center gap-3'>
          {icon && (
            <div className='inline-flex h-9 w-9 items-center justify-center rounded-md border border-curitec-orange/30 bg-white text-curitec-orange'>
              {icon}
            </div>
          )}

          {title && (
            <div className='min-w-0'>
              {subtitle && <div className='text-xs text-base-content/70'>{subtitle}</div>}
              <div className='flex flex-wrap items-baseline gap-2'>
                <span className='truncate max-w-[60vw] sm:max-w-xs font-medium text-base-content'>{title}</span>
              </div>
            </div>
          )}
        </div>

        <div className='flex items-center gap-2 w-full sm:w-auto justify-end'>{right}</div>
      </div>
    </div>
  )
}
